import {
  FaStore,
  FaTruck,
  FaCalendarAlt,
  FaMoneyBillWave,
} from "react-icons/fa";
import { dateSetup } from "./stock-ordering-utils";

interface PaymentOrderInformationProps {
  orderData: any;
}

export function PaymentOrderInformation(props: PaymentOrderInformationProps) {
  const { orderData } = props;

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-PH", {
      style: "currency",
      currency: "PHP",
    }).format(amount);
  };

  if (!orderData) {
    return null;
  }

  return (
    <div className="border rounded-2xl shadow-sm p-5 bg-white">
      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center space-x-2">
        <FaStore className="text-green-600" />
        <span>Order Information</span>
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* PO Number */}
        <div className="bg-gray-50 rounded-lg p-3">
          <p className="text-xs text-gray-500 uppercase font-medium">
            PO Number
          </p>
          <p className="text-gray-900 font-semibold text-lg">
            {orderData.po_number || `ORD-${orderData.id}`}
          </p>
        </div>

        {/* Store */}
        <div className="bg-gray-50 rounded-lg p-3">
          <p className="text-xs text-gray-500 uppercase font-medium">Store</p>
          <p className="text-gray-900 font-semibold">{orderData.store_name}</p>
        </div>

        {/* Supplier */}
        <div className="bg-gray-50 rounded-lg p-3">
          <p className="text-xs text-gray-500 uppercase font-medium">
            Supplier
          </p>
          <p className="text-gray-900 font-semibold">
            {orderData.supplier_name}
          </p>
        </div>

        {/* Order Date */}
        <div className="bg-gray-50 rounded-lg p-3">
          <div className="flex items-center space-x-2 mb-1">
            <FaCalendarAlt className="text-blue-500 text-xs" />
            <p className="text-xs text-gray-500 uppercase font-medium">
              Order Date
            </p>
          </div>
          <p className="text-gray-900 font-semibold">
            {orderData.order_placement_date
              ? dateSetup(orderData.order_placement_date, false)
              : "N/A"}
          </p>
        </div>

        {/* Delivery Date */}
        <div className="bg-gray-50 rounded-lg p-3">
          <div className="flex items-center space-x-2 mb-1">
            <FaTruck className="text-green-500 text-xs" />
            <p className="text-xs text-gray-500 uppercase font-medium">
              Delivery Date
            </p>
          </div>
          <p className="text-gray-900 font-semibold">
            {orderData.actual_delivery_date
              ? dateSetup(orderData.actual_delivery_date, false)
              : orderData.requested_delivery_date
                ? dateSetup(orderData.requested_delivery_date, false)
                : "N/A"}
          </p>
        </div>

        {/* Total Amount */}
        <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg p-3 border border-green-200">
          <div className="flex items-center space-x-2 mb-1">
            <FaMoneyBillWave className="text-green-600 text-xs" />
            <p className="text-xs text-green-700 uppercase font-medium">
              Total Amount
            </p>
          </div>
          <p className="text-green-700 font-bold text-xl">
            {formatCurrency(orderData.total_cost || 0)}
          </p>
        </div>
      </div>
    </div>
  );
}
